import create from "zustand";
import { mapValues, has } from "lodash-es";
import { Bundle } from "../interfaces";

import { immer } from "../lib";

type State = {
  allVisible: boolean;
  visibilityMap: Record<string, boolean>;
  cloneModalOpen: boolean;
  createModalOpen: boolean;
  openCreateModal: () => void;
  closeCreateModal: () => void;
  openCloneModal: (bundle: Bundle) => void;
  closeCloneModal: () => void;
  bundleToClone?: Bundle;
  toggleAllVisibility: () => void;
  toggleVisibility: (id: string) => void;
  registerVisibility: (id: string) => void;
};

export const useBundleStore = create<State>(
  immer((set) => ({
    allVisible: false,
    visibilityMap: {},
    cloneModalOpen: false,
    createModalOpen: false,
    bundleToClone: undefined,
    registerVisibility: (id) =>
      set((state) => {
        if (!has(state.visibilityMap, id)) {
          state.visibilityMap[id] = false;
        }
      }),
    toggleVisibility: (id) =>
      set((state) => {
        state.visibilityMap[id] = !state.visibilityMap[id];
      }),
    toggleAllVisibility: () =>
      set((state) => {
        const current = state.allVisible;
        state.allVisible = !current;
        state.visibilityMap = mapValues(state.visibilityMap, () => !current);
      }),
    openCreateModal: () =>
      set((state) => {
        state.createModalOpen = true;
      }),
    closeCreateModal: () =>
      set((state) => {
        state.createModalOpen = false;
      }),
    openCloneModal: (bundle: Bundle) =>
      set((state) => {
        state.cloneModalOpen = true;
        state.bundleToClone = bundle;
      }),
    closeCloneModal: () =>
      set((state) => {
        state.cloneModalOpen = false;
      }),
  }))
);
